module.exports = __webpack_public_path__ + "static/media/clocards-create.a8e3ce4e.png";